import React, { useEffect, useState } from "react";
import {
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  TabPane
} from "reactstrap";
const Tabs = ({ activeTab, toggleTab, tabs, loader }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <Nav
        tabs
        className="d-flex justify-content-start text-dark athlete_earning-nav"
      >
        {tabs.map((tab) => (
          <NavItem key={tab?.id}>
            <NavLink
              className={
                activeTab === tab?.id
                  ? "active active-tab py-2 nav-link-hover bg-primary"
                  : "text-dark py-2 nav-link-hover"
              }
              onClick={() => {
                toggleTab(tab?.id);
              }}
            >
              <h2
                className={activeTab === tab?.id ? "text-white" : ""}
                style={{
                  fontSize: isSmallScreen ? "13px" : "24px",
                  textTransform: "uppercase"
                }}
              >
                {tab.title}
              </h2>
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <TabContent activeTab={activeTab} className="p-3 athlete-earning-content">
        {tabs.map((tab) => (
          <TabPane tabId={tab?.id} key={tab?.id}>
            {loader ? (
              <div className="text-center">
                <Spinner />
              </div>
            ) : (
              tab?.content
            )}
          </TabPane>
        ))}
      </TabContent>
    </div>
  );
};
export default Tabs;
